import { Table, TableBody } from '@mui/material';
import { useContainer } from 'unstated-next';

import DraftTemplateRow from './DraftTemplateRow';
import TemplatesTableHeader from './TemplatesTableHeader';
import { useDeleteModal } from '../hooks/useDeleteModal';
import { useTemplateStatusModal } from '../hooks/useTemplateStatusModal';
import DeleteTemplateModal from '../Modals/DeleteTemplateModal';
import UpdateTemplateStatusModal from '../Modals/TemplateStatusModal';
import TemplateContainer from '../TemplateContext';
import { ActionType } from '../types';

const DraftTemplates = () => {
    const { draftTemplates, deleteDraftTemplate, publishTemplate } = useContainer(TemplateContainer);
    const { deleteModalIsOpen, openDeleteModal, templateToDelete, closeDeleteModal } = useDeleteModal();
    const { statusModalIsOpen, openPublishModal, templateIdToPublish, closePublishModal } = useTemplateStatusModal();

    const handleDelete = () => {
        const templateId = templateToDelete?.sid;

        if (templateId) {
            closeDeleteModal();
            deleteDraftTemplate(templateId);
        }
    };

    const handlePublish = () => {
        if (templateIdToPublish) {
            closePublishModal();
            publishTemplate(templateIdToPublish);
        }
    };

    return (
        <Table>
            <TemplatesTableHeader />
            <TableBody>
                {draftTemplates.map((draftTemplate) => (
                    <DraftTemplateRow
                        openDeleteModal={openDeleteModal}
                        openPublishModal={openPublishModal}
                        template={draftTemplate}
                        key={draftTemplate.sid}
                    />
                ))}
            </TableBody>

            <DeleteTemplateModal
                open={deleteModalIsOpen}
                onClose={closeDeleteModal}
                handleDelete={handleDelete}
                templateToDelete={templateToDelete}
            />
            <UpdateTemplateStatusModal
                open={statusModalIsOpen}
                onClose={closePublishModal}
                actionType={ActionType.Publish}
                handleUpdate={handlePublish}
            />
        </Table>
    );
};

export default DraftTemplates;
